

  export async function getAllInventoryReasons(repository) {
    const reasons = await repository.getAll()
    return reasons.map(reason => reason.toPrimitives())
  }

